import { render, staticRenderFns } from "./reset-password.vue?vue&type=template&id=b20851a6&scoped=true&lang=pug"
import script from "./reset-password.vue?vue&type=script&lang=ts"
export * from "./reset-password.vue?vue&type=script&lang=ts"
import style0 from "./reset-password.vue?vue&type=style&index=0&id=b20851a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20851a6",
  null
  
)

export default component.exports